import type { ReactNode } from 'react'
import './Testimonial.css'

export interface TestimonialProps {
  avatarSrc?: string
  quote: ReactNode
  name: ReactNode
}

export function Testimonial({ avatarSrc, quote, name }: TestimonialProps) {
  return (
    <div className="azoya-testimonial">
      {avatarSrc ? (
        <img className="azoya-testimonial-avatar" src={avatarSrc} alt="" aria-hidden="true" />
      ) : (
        <div className="azoya-testimonial-avatar" aria-hidden="true" />
      )}
      <div>
        <p className="azoya-testimonial-text">{quote}</p>
        <p className="azoya-testimonial-name">{name}</p>
      </div>
    </div>
  )
}
